export default __webpack_public_path__ + "static/media/fact_sheet48.bc49705d.png";